import type { FaireProductEntity } from "../../entity_types/product";

export const p_x3vc5r4ena: FaireProductEntity = {
  token: "p_x3vc5r4ena",
  type: "product",
  name: "Colorful Kitty Patchwork hobo",
  brandToken: "b_9jg4fbzgpg",
  brandName: "Like International",
  imageUrl:
    "https://cdn.faire.com/fastly/b17439a2eafabe666753b15a66e72d8b2a49eded80ceb6fd85ad47c617c708e3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6fa43b91a476c538d5ec41f9df59e5da48530bc1300e879507323b491cd14b89.jpeg",
    "https://cdn.faire.com/fastly/79aa38d26e9b9819d8b5c17935b84b9ccae95f78b4007b9a2e07d450641a3831.jpeg",
    "https://cdn.faire.com/fastly/863128eab377c0d57fb0112fc360e40d9d41cad7744ea6165c9ca552ea6b4a37.jpeg",
    "https://cdn.faire.com/fastly/ebc7193a8c3be8f5e166861df7d187629253cba8e9850bf79811b5ad98065510.jpeg",
  ],
  priceDollars: 18.5,
  description:
    "This beautiful Cat-Print Shoulder Bag is PURR-fect as an everyday bag, shopping bag, stylish purse, or even a cute gift for a loved one!\n HELPFUL DETAILS:\n ➼ SUPER High-Quality Cotton Fabric\n ➼ Beautiful + Boho Stonewash/Razor Cut Design!\n ➼ Main Compartment Dimensions: 10 inches x 11 inches\n ➼ Top to Bottom (top of strap to bottom of the bag): 35 inches\n ➼ Total of 5 Pockets - Zipper closable Main Compartment\n - Secret Velcro Pocket on the INSIDE of the main compartment, too!\n - TWO Front Pockets on Front of Bag\n - Helpful Velcro Pocket on Strap for keys, money, phone, hand sanitizer, and more!\n ➼ Perfect for festivals, beach days, shopping, errands, parties, walks, and more!",
  tags: [],
  msrpDollars: 37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:02.368Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
